import { gql } from '../../gql';

export const GET_SURVEY_TEMPLATE_IDS = gql(`
  query GetWSSurveyTemplateIds(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterHazardSurveyTemplates(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
    }
  }
`);

export const GET_SURVEY_TEMPLATES = gql(`
  query GetWSSurveyTemplates(
    $where: JSON
    $orderBy: [ColumnOrder]
    $limit: Int
    $offset: Int
  ) {
    waterHazardSurveyTemplates(
      where: $where
      orderBy: $orderBy
      limit: $limit
      offset: $offset
    ) {
      id
      name
      description
      instructions
      otherHazardsQuestion
      protectedQuestion
      waterSupplierId
      items {
        waterHazardId
        displayOrder
        waterHazard {
          id
          name
          hazardLevel
        }
      }
    }
  }
`);

export const CREATE_SURVEY_TEMPLATE = gql(`
  mutation WSCreateSurveyTemplate($input: WaterHazardSurveyTemplateInput!) {
    createWaterHazardSurveyTemplate(input: $input) {
      id
      name
      description
      instructions
      otherHazardsQuestion
      protectedQuestion
      waterSupplierId
    }
  }
`);

export const UPDATE_SURVEY_TEMPLATE = gql(`
  mutation WSUpdateSurveyTemplate(
    $templateId: ID!
    $input: WaterHazardSurveyTemplateInput!
  ) {
    updateWaterHazardSurveyTemplate(templateId: $templateId, input: $input) {
      id
      name
      description
      instructions
      otherHazardsQuestion
      protectedQuestion
      waterSupplierId
    }
  }
`);

export const DELETE_SURVEY_TEMPLATE = gql(`
  mutation WSDeleteSurveyTemplate($templateId: ID!) {
    deleteWaterHazardSurveyTemplate(templateId: $templateId)
  }
`);

export type SurveyTemplateItem = {
  id: string;
  name: string;
  description: string;
  instructions: string | null;
  otherHazardsQuestion: boolean;
  protectedQuestion: boolean;
  waterSupplierId: string | null;
  items: {
    waterHazardId: string;
    displayOrder: number;
    waterHazard: {
      id: string;
      name: string;
      hazardLevel: string;
    };
  }[];
};
